<div
  class="mark"
  [class.mark--has-label]="label"
  [matTooltip]="text"
  [matTooltipPosition]="position"
  [class]="['mark--margin-left-' + marginLeftType]"
  matTooltipClass="question-tooltip">
  ?
</div>
